<template lang="pug">
  .layout
    y-dialog(v-if="showModal" v-model='showModal', scrollable='', max-width='600px' persistent)
      v-card
        v-card-title.px-4
          v-layout
            div.h6.basic800--text {{ $t('addons') }}
            v-spacer
            v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="showAddProductDialog =! showAddProductDialog")
              v-icon.mr-1(small) mdi-plus
              | {{ $t('create_addon') }}

        v-divider.basic300
        v-card-text.px-1.pb-3
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          .contain-layout(v-else)
            v-layout.my-6(v-if="products.length == 0")
              v-row.fill-height.ma-0(align='center' justify='center')
                div.mx-auto
                  v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                  p.caption {{ $t('no_addons_yet') }}
            .items-layout(v-else)
              template(v-for='product in products')
                add-on-product-item(:product="product" :key="product.id" @deleted="handleDeleteItem" :setweight="setweight" :setdimension="setdimension")
                v-divider.basic300
          y-pagination.ma-4(v-model="page" :pageSize="fetchCount" :count="count")
          
        v-card-actions
          v-spacer
          v-btn(color='white' text @click='showModal = false')
            .button-AA-small.primary400--text {{ $t('close') }}
    
    .modals
      add-new-add-on(v-if="showAddProductDialog" :open.sync="showAddProductDialog" :productId="productId" @added="handleAddItem" :setweight="setweight" :setdimension="setdimension")

</template>

<script>
import AddOnProductItem from '@/components/AddOnProductItem.vue'
import AddNewAddOn from '@/components/dialogs/AddNewAddOn.vue'

export default {
  name: 'ManageProductAddOnsDialog',
  props: ['open', 'productId', 'setweight', 'setdimension'],
  components: { AddOnProductItem, AddNewAddOn },
  data: () => ({
    isFetching: false,
    fetchCount: 10,
    page: 1,
    // totalPage: 1,
    count: 0,
    products: [],
    showAddProductDialog: false
  }),
  mounted () {
    this.fetchProducts(1)
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {
    page (val) {
      if (!this.isFetching) {
        this.fetchProducts(val)
      }
    }
  },
  methods: {
    fetchProducts(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/products/${this.productId}/addons/?page=${page}&page_size=${this.fetchCount}&ordering=-id`
      if (this.searchText) {
        url += `&search=${this.searchText}`
      }
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.products = response.data.results
        this.count = response.data.count
        // const totalCount = response.data.count
        // if (totalCount % this.fetchCount == 0) {
        //   this.totalPage = totalCount/this.fetchCount
        // } else {
        //   this.totalPage = totalCount/this.fetchCount + 1
        // }
        // this.totalPage = parseInt(this.totalPage)
      })
      .catch(() => {})
    },
    handleDeleteItem (item) {
      this.products = this.products.filter((x) => x !== item)
    },
    handleAddItem (item) {
      this.products.splice(0, 0, item)
      this.$emit('activated')
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "create_addon": "Create Add-on",
    "no_addons_yet": "No add-ons yet"
  },
  "id": {
    "create_addon": "Create Add-on",
    "no_addons_yet": "Tiada add-ons"
  }
}
</i18n>
